import React from "react";
import {useNavigate} from "react-router-dom"
import Paging from '../../component/Paging'

const ProductReview = () => {
  const navigate = useNavigate();
  return (
    <main>
      <h2 className="adm_com_pg_tit">시술후기 목록</h2>
      <div className="adm_com_pg_content">
        <div className="adm_com_btn_wrap">
          <select className="select">
            <option value="최근등록순">최근등록순</option>
          </select>
        </div>
        <table className='adm_com_board_list'>
          <colgroup>
            <col width="5%"/><col width="10%"/><col width="10%"/><col width="10%"/><col width="10%"/>
            <col width="10%"/><col width="10%"/><col width="10%"/><col width="10%"/><col width="10%"/>
          </colgroup>
          <thead>
            <tr>
              <th>번호</th>
              <th>카테고리</th>
              <th>이름/성별</th>
              <th>닉네임</th>
              <th>시술명</th>
              <th>시술부위</th>
              <th>등록일자</th>
              <th>조회수</th>
              <th>노출여부</th>
              <th>관리</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>5</td>
              <td>보톡스</td>
              <td>김올리/여</td>
              <td>올리5</td>
              <td>모공 보톡스</td>
              <td>입,기타</td>
              <td>2023-12-12</td>
              <td>10</td>
              <td>
                <input type="checkbox" className="adm_com_chk" id="chk01" name="chk01" value="Y" />
                <label htmlFor="chk01">Y</label>
              </td>
              <td>
                <button onClick={() => navigate("/Board/Manage/ProductReview/Detail")} className="adm_com_btn blue line">상세</button>
                <button className="adm_com_btn gray line">삭제</button>
              </td>
            </tr>
          </tbody>
        </table>
        <Paging />
      </div>
    </main>
  )
};

export default ProductReview;
